/* eslint-disable */
import React from 'react';
import 'contents/assets/scss/page/statistics.scss';
//chart
import VerticalBarChart from '../../component/Inc/VerticalBarChart';
import LineChart from '../../component/Inc/LineChart';

function Index() {
  const lineChartWidth = '100%';
  const lineChartHeight = '100px';
  const barChartWidth = '100%';
  const barChartHeight = '100px';
  //barchart labels
  const labels = ['시범강의', '시범강의', '교사지목', '교사지목', '추가', '신규', '타임추가', '취소', '중단', '인계', '종료', '타임축소'];
  //Linechartlabels
  const lineChartlabels = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];

  //barchart data
  const data = {
    labels,
    datasets: [
      {
        data: [8890, 8890, 8890, 8890, 8890, 8890, 8890, 8890, 8890, 8890, 8890, 8890],
        backgroundColor: '#3780ff',
        borderColor: '#3780ff',
        borderWidth: 1
      },
      {
        data: [6500, 6500, 6500, 6500, 6500, 6500, 6500, 6500, 6500, 6500, 6500, 6500],
        backgroundColor: '#fc8019',
        borderColor: '#fc8019',
        borderWidth: 1
      }
    ]
  };

  //line chart data
  const lineChartData = {
    lineChartlabels,
    datasets: [
      {
        label: '2022',
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#fc8019'
      },
      {
        label: '2023',
        data: [1, 4, 5, 2, 5, 9, 7, 6, 6, 1, 8, 5],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#3780ff'
      }
    ]
  };
  return (
    <main className="com_container com_statistics p_statistics">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu10_1">영업 실적</h2>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
              </div>
              <section className="com_board_search end">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">주간</button>
                  <button className="com_btn line gray s">월간</button>
                </div>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
              </section>
            </div>
            <hr className="com_divider" />
            {/*  영업실적 그래프 */}
            <div className="stats_chart">
              <div className="bar_chart_wrap">
                <div className="com_chart_wrapper">
                  <div className="detail_tit dot">연간 비교</div>
                  <div className="com_chart_wrap">
                    <div className="chart_body">
                      <div className="chart_name">
                        <div className="chart_item">
                          <span className="chart_name_label">2021</span>
                          <div className="chart_box chart_blue"></div>
                        </div>
                        <div className="chart_item">
                          <span className="chart_name_label">2021</span>
                          <div className="chart_box chart_orange"></div>
                        </div>
                      </div>
                      <div className="chart_content">
                        <VerticalBarChart data={data} width={barChartWidth} height={barChartHeight} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="com_chart_wrapper">
                  <div className="detail_tit dot">월간 비교</div>
                  <div className="com_chart_wrap">
                    <div className="chart_body">
                      <div className="chart_name">
                        <div className="chart_item">
                          <span className="chart_name_label">2021</span>
                          <div className="chart_box chart_blue"></div>
                        </div>
                        <div className="chart_item">
                          <span className="chart_name_label">2021</span>
                          <div className="chart_box chart_orange"></div>
                        </div>
                      </div>
                      <div className="chart_content">
                        <VerticalBarChart data={data} width={barChartWidth} height={barChartHeight} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="com_chart_wrapper">
                  <div className="detail_tit dot">주간 비교</div>
                  <div className="com_chart_wrap">
                    <div className="chart_body">
                      <div className="chart_name">
                        <div className="chart_item">
                          <span className="chart_name_label">2021</span>
                          <div className="chart_box chart_blue"></div>
                        </div>
                        <div className="chart_item">
                          <span className="chart_name_label">2021</span>
                          <div className="chart_box chart_orange"></div>
                        </div>
                      </div>
                      <div className="chart_content">
                        <VerticalBarChart data={data} width={barChartWidth} height={barChartHeight} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="progress_chart_wrap">
                <div className="com_chart_wrapper">
                  <div className="detail_tit dot">중단</div>
                  <div className="com_chart_wrap">
                    <div className="chart_body">
                      <div className="chart_name">
                        <div className="chart_item">
                          <span className="chart_name_label">2023</span>
                          <div className="chart_slider chart_blue"></div>
                        </div>
                        <div className="chart_item">
                          <span className="chart_name_label">2022</span>
                          <div className="chart_slider chart_orange"></div>
                        </div>
                      </div>
                      <div className="chart_content">
                        <LineChart data={lineChartData} width={lineChartWidth} height={lineChartHeight} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="com_chart_wrapper">
                  <div className="detail_tit dot">인계</div>
                  <div className="com_chart_wrap">
                    <div className="chart_body">
                      <div className="chart_name">
                        <div className="chart_item">
                          <span className="chart_name_label">2023</span>
                          <div className="chart_slider chart_blue"></div>
                        </div>
                        <div className="chart_item">
                          <span className="chart_name_label">2022</span>
                          <div className="chart_slider chart_orange"></div>
                        </div>
                      </div>
                      <div className="chart_content">
                        <LineChart data={lineChartData} width={lineChartWidth} height={lineChartHeight} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*  영업실적 표 */}
            <div className="com_table_wrap">
              <div className="com_table_wrapper">
                <div className="detail_tit dot">월 별 타임수 증가율</div>
                <table className="com_board_list">
                  <colgroup>
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12 +8%)' }}" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>구분</th>
                      <th>1월</th>
                      <th>2월</th>
                      <th>3월</th>
                      <th>4월</th>
                      <th>5월</th>
                      <th>6월</th>
                      <th>7월</th>
                      <th>8월</th>
                      <th>9월</th>
                      <th>10월</th>
                      <th>11월</th>
                      <th>12월</th>
                      <th>합계</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>2021</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>69,327</td>
                    </tr>
                    <tr>
                      <td>2022</td>
                      <td>653</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>69,327</td>
                    </tr>
                    <tr>
                      <td>2023</td>
                      <td>779</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>69,327</td>
                    </tr>
                    <tr>
                      <td>증감</td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue down">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">69.327</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="com_table_wrapper">
                <div className="detail_tit dot">월 별 과목 증가율</div>
                <table className="com_board_list">
                  <colgroup>
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12 +8%)' }}" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>구분</th>
                      <th>1월</th>
                      <th>2월</th>
                      <th>3월</th>
                      <th>4월</th>
                      <th>5월</th>
                      <th>6월</th>
                      <th>7월</th>
                      <th>8월</th>
                      <th>9월</th>
                      <th>10월</th>
                      <th>11월</th>
                      <th>12월</th>
                      <th>합계</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>2021</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>69,327</td>
                    </tr>
                    <tr>
                      <td>2022</td>
                      <td>653</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>69,327</td>
                    </tr>
                    <tr>
                      <td>2023</td>
                      <td>779</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>69,327</td>
                    </tr>
                    <tr>
                      <td>증감</td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue down">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">126</span>
                      </td>
                      <td>
                        <span className="arrow_blue">69.327</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="com_table_wrapper">
                <div className="detail_tit dot">수시 월별 매출 통계</div>
                <table className="com_board_list">
                  <colgroup>
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>구분</th>
                      <th>1월</th>
                      <th>2월</th>
                      <th>3월</th>
                      <th>직할</th>
                      <th>총계</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>신규</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>69,327</td>
                    </tr>
                    <tr>
                      <td>소개</td>
                      <td>653</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>69,327</td>
                    </tr>
                    <tr>
                      <td>추가</td>
                      <td>779</td>
                      <td>809</td>
                      <td>809</td>
                      <td>809</td>
                      <td>69,327</td>
                    </tr>
                    <tr>
                      <td>총 과목</td>
                      <td>292.5</td>
                      <td>258</td>
                      <td>282</td>
                      <td>148</td>
                      <td>69,327</td>
                    </tr>
                    <tr className="summarized_rows">
                      <td>2023</td>
                      <td>312,885,000</td>
                      <td>332,032,000</td>
                      <td>376,360,500</td>
                      <td>326,110,000</td>
                      <td>1,347,387,500</td>
                    </tr>
                    <tr className="summarized_rows">
                      <td>2022</td>
                      <td>3,150,000</td>
                      <td>1,057,000</td>
                      <td>547,000</td>
                      <td>3,150,000</td>
                      <td>1,057,000</td>
                    </tr>

                    <tr className="summarized_rows">
                      <td>증감율</td>
                      <td className="td_red">
                        <span className="arrow_blue">3214</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">3214</span>
                      </td>
                      <td className="td_red">
                        <span className="arrow_blue">3214</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">3214</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">3214</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Index;
